import { Reveal } from "@/components/Reveal";
import { ArrowUpRight, MapPin, BadgeCheck, Quote } from "lucide-react";

const SPECIALITIES = ["Early Intervention", "Articulation & Language", "Autism-Affirming Care"];

export const Team = ({ onBook }) => (
  <section id="founder" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
    <Reveal>
      <p className="mb-4 font-mono text-xs font-medium uppercase tracking-[0.28em] text-pine-700">About the founder</p>
      <h2 className="max-w-xl font-serif text-2xl font-semibold tracking-tight text-pine-950 sm:text-3xl lg:text-4xl">
        Care led personally, never passed around.
      </h2>
    </Reveal>

    <Reveal delay={0.1}>
      <article
        data-testid="therapist-profile-card"
        className="mt-14 grid grid-cols-1 overflow-hidden rounded-3xl border border-pine-900/10 bg-white md:grid-cols-12"
      >
        <div className="relative overflow-hidden bg-sand md:col-span-5">
          <img
            src="/assets/founder.jpg"
            alt="Sameeksha Shetty, founder of SpellingBee Therapy Services"
            className="h-full w-full object-cover object-top transition-transform duration-700 ease-out hover:scale-105"
            data-testid="founder-photo"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-pine-950/30 to-transparent" />
          <span className="absolute bottom-5 left-5 flex items-center gap-2 rounded-full bg-white/90 px-4 py-2 text-xs font-semibold text-pine-900 backdrop-blur-sm">
            <MapPin size={13} className="text-clay" /> North Bengaluru
          </span>
        </div>

        <div className="flex flex-col justify-between p-8 sm:p-12 md:col-span-7">
          <div>
            <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-clay">
              <BadgeCheck size={14} /> RCI-Registered Speech-Language Pathologist
            </p>
            <h3 className="mt-4 font-serif text-2xl font-semibold text-pine-950 sm:text-3xl" data-testid="founder-name">
              Sameeksha Shetty
            </h3>
            <p className="mt-2 text-sm font-medium text-stone-500" data-testid="founder-credentials">
              Reg. No. A58697 · 9 years' experience
            </p>
            <blockquote className="mt-7 border-l-4 border-honey pl-5">
              <Quote size={18} className="mb-2 text-clay" fill="currentColor" strokeWidth={0} />
              <p className="font-serif text-lg font-medium italic leading-relaxed text-pine-900 sm:text-xl" data-testid="founder-quote">
                I believe every child can communicate. My job is to find the way in.
              </p>
            </blockquote>
            <p className="mt-6 max-w-lg text-sm leading-relaxed text-stone-600 sm:text-base">
              Sameeksha has spent nine years helping children find their voice —
              in clinics, classrooms, and homes across Bengaluru. She leads every
              school partnership personally, from the first screening to the
              four-week review.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {SPECIALITIES.map((s) => (
                <span key={s} className="rounded-full bg-sand px-3 py-1 text-[11px] font-medium text-pine-700">
                  {s}
                </span>
              ))}
            </div>
          </div>
          <button
            data-testid="therapist-book-button"
            onClick={() => onBook()}
            className="group mt-8 flex w-fit items-center gap-2 rounded-full bg-pine-900 px-7 py-3.5 text-sm font-semibold text-cream transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-pine-800"
          >
            Book a free consult
            <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
      </article>
    </Reveal>
  </section>
);
